import React from 'react';

export interface MasUsuarioIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const MasUsuarioIcon: React.FC<MasUsuarioIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M26.544 22.75v-2a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v2M4.75 12.845h3m0-3v3m0 0v3m0-3h3M22.544 8.75a4 4 0 1 1-8 0 4 4 0 0 1 8 0"/></g><defs><filter id="a" width="32" height="32" x="-.456" y="-2.25" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_84_127533"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_84_127533" mode="multiply" result="effect2_dropShadow_84_127533"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_84_127533" result="shape"/></filter></defs>
    </svg>
  );
};

export default MasUsuarioIcon;
